import React, { PropsWithChildren, useMemo, useState } from 'react';
import DossierCustomHeaderContext from './DossierCustomHeaderContext';

const DossierCustomHeaderProvider: React.FunctionComponent<PropsWithChildren> = function ({
    children,
}) {
    const [isDossierValidationPath, setDossierValidationPath] = useState<boolean>(false);
    const [isDossierDetailPath, setIsDossierDetailPath] = useState<boolean>(false);
    // useState receives a lazy initializer; to initialize the state with a function value
    // provide a function that returns the actual callback function
    const [onExit, setOnExit] = useState<() => void>(() => () => {});
    const [headerTitle, setHeaderTitle] = useState<string>('Vérifier les informations du dossier');
    const [headerButton, setHeaderButton] = useState<string>('Enregister et quitter');
    const [pathOnExit, setPathOnExit] = useState<string | null>(null);
    const [actionsBloc, setActionsBloc] = useState<React.ReactNode>(null);

    const contextValue = useMemo(
        () => ({
            isDossierValidationPath,
            setDossierValidationPath,
            isDossierDetailPath,
            setIsDossierDetailPath,
            onExit,
            setOnExit,
            headerTitle,
            setHeaderTitle,
            headerButton,
            setHeaderButton,
            pathOnExit,
            setPathOnExit,
            actionsBloc,
            setActionsBloc,
        }),
        [
            isDossierValidationPath,
            setDossierValidationPath,
            isDossierDetailPath,
            setIsDossierDetailPath,
            onExit,
            setOnExit,
            headerTitle,
            setHeaderTitle,
            headerButton,
            setHeaderButton,
            pathOnExit,
            setPathOnExit,
            actionsBloc,
            setActionsBloc,
        ],
    );

    return (
        <DossierCustomHeaderContext.Provider
            value={contextValue as React.ContextType<typeof DossierCustomHeaderContext>}
        >
            {children}
        </DossierCustomHeaderContext.Provider>
    );
};

export default DossierCustomHeaderProvider;
